import React from 'react';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import TemplateForm from './TemplateForm';
import TemplateTable from './TemplateTable';

const Whatsapp = () => {
    const [templateRefresh, setTemplateRefresh] = React.useState(false);
    const [zoomIn, setZoomIn] = React.useState();
    return (
      <div>
        <Breadcrumbs
          aria-label="breadcrumb"
          sx={{
        marginBottom: '5px',
      }}
        >
          <Typography sx={{ color: 'text.primary' }}>Admin</Typography>
          <Typography sx={{ color: 'text.primary' }}>Whatsapp Setting</Typography>
        </Breadcrumbs>
       
        {!zoomIn && (
        <div className="excel-upload">
          <TemplateForm setTemplateRefresh={setTemplateRefresh} />
        </div>
       )}
        {/* <div className="">
          <TemplateForm setTemplateRefresh={setTemplateRefresh} />
        </div> */}
        <div className="template-table">
          <TemplateTable 
            templateRefresh={templateRefresh}
            setZoomIn={setZoomIn}
            zoomIn={zoomIn}
            setTemplateRefresh={setTemplateRefresh}
          />
        </div>
      </div>
  );
};

export default Whatsapp;
